<template>
    <div>
        <div v-if="data.length" class="attachments">
            <div class="main-title main-title--small">Pliki do pobrania</div>
            <div class="attachments__row">
                <div v-for="item in data" :key="item.Id" class="attachments__item">
                    <a class="attachments__icon" :href="`${path}/${item.File}`" :download="getFileSlug(item.File, item.Name)">
                        <i class="material-icons">cloud_download</i>
                    </a>
                    <span class="attachments__name">{{ item.Name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
export default {
    name: "Attachments",
    props: {
        id: {
            type: Number,
            required: true,
            default: 0
        },
        storage: {
            type: String,
            required: true,
            default: 'subpagesfiles'
        },
        path: {
            type: String,
            required: true,
            default: '/file/subpages/attachments'
        }
    },
    data() {
        return {
            data: [],
            isFetching: false
        }
    },
    methods: {
        async fetch() {
            if (!this.isFetching) {
                this.isFetching = true;
                try {
                    let { data } = await this.$http.post('/load-attachments', {
                        id: this.id,
                        storage: this.storage
                    });
                    Vue.set(this.$data, "data", data.data);
                } catch (error) {
                    console.log(error);
                }
                this.isFetching = false;
            }
        },
        getFileSlug(filename, name) {
            let f = filename.split('.');
            return name.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'') + "." + f.pop();
        }
    },
    created() {
        this.fetch();
    }
}
</script>

<style lang="scss" scoped>

</style>